module.exports = __webpack_public_path__ + "img/GüldenesLicht.0c0dd476.jpg";